// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Grid.css */
.grid-container {
    width: 98vw;
    height: auto;
    padding:0.25em;
  }
  
  .grid-item {
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);
  }
  
  .react-grid-layout {
    position: relative;
    transition: height 200ms ease;
  }
  
  .react-grid-item {
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);
  }
  
  .react-grid-item.react-grid-placeholder {
    background-color: #fff;
  }
  
  .react-grid-item.cssTransforms {
    transition: none;
  }
  
  .react-grid-item.cssTransforms .react-draggable-dragging {
    transition: none;
  }`, "",{"version":3,"sources":["webpack://./src/components/grid/grid.css"],"names":[],"mappings":"AAAA,aAAa;AACb;IACI,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB","sourcesContent":["/* Grid.css */\n.grid-container {\n    width: 98vw;\n    height: auto;\n    padding:0.25em;\n  }\n  \n  .grid-item {\n    background-color: white;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);\n  }\n  \n  .react-grid-layout {\n    position: relative;\n    transition: height 200ms ease;\n  }\n  \n  .react-grid-item {\n    background-color: white;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);\n  }\n  \n  .react-grid-item.react-grid-placeholder {\n    background-color: #fff;\n  }\n  \n  .react-grid-item.cssTransforms {\n    transition: none;\n  }\n  \n  .react-grid-item.cssTransforms .react-draggable-dragging {\n    transition: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
